/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs */

const en_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom App Allow List`)
};

const ar_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة السماح بالتطبيق في وضع تركيز عميق`)
};

const de_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassbare Liste zugelassener Apps`)
};

const es_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de apps permitidas personalizada`)
};

const fr_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des autorisations de Forest personnalisée`)
};

const it_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista App Consentite personalizzata`)
};

const ja_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタマイズできるアプリ許可リスト`)
};

const ko_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤 앱 허용 리스트`)
};

const pt_br_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de permissões de aplicativos no Foco Total`)
};

const ru_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список разрешенных приложений для глубокой фокусировки`)
};

const th_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปรับแต่งรายการอนุญาตแอป`)
};

const tr_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derin odaklanma için İzinli Uygulama Listesi`)
};

const zh_cn_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深度专注应用程序白名单`)
};

const zh_tw_win_back_paywall_benefit_custom_app_allow_list = /** @type {(inputs: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深度專注允許名單`)
};

/**
* | output |
* | --- |
* | "Custom App Allow List" |
*
* @param {Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_custom_app_allow_list = /** @type {((inputs?: Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_Custom_App_Allow_ListInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_custom_app_allow_list(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_custom_app_allow_list(inputs)
	return zh_tw_win_back_paywall_benefit_custom_app_allow_list(inputs)
});